<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 class="mt-4 px-0">
        <h5 class="border-top font-weight-bold">
          Phiếu thu {{ index + 1 }}
          <v-btn @click="removeReceipt(index)" color="red" flat small v-if="!(receipt_state.receipt_type === INCOME_TYPE.RECEIPT_CASH && receipt_state.bank_transaction_id)">
            Xóa
            <v-icon>delete</v-icon>
          </v-btn>
        </h5>
      </v-flex>
      <v-flex xs12 md3>
        <v-select
          :items="RECEIPT_INCOME_TYPE"
          :disabled="loading.submit || loading.form || (receipt_state.receipt_type === INCOME_TYPE.RECEIPT_CASH && receipt_state.bank_transaction_id)"
          :rules="[rules.required]"
          v-model="receipt_state.receipt_type"
          prepend-icon="list"
          label="Loại thu"
        ></v-select>
      </v-flex>
      <v-flex xs12 md3>
        <v-select
          label="Tòa nhà"
          :disabled="
            loading.submit ||
              loading.form ||
              receipt_state.receipt_type === INCOME_TYPE.RECEIPT_OTHER ||
              receipt_state.receipt_type === INCOME_TYPE.RECEIPT_GAM ||
              receipt_state.receipt_type === INCOME_TYPE.RECEIPT_LOAN ||
              (receipt_state.receipt_type === INCOME_TYPE.RECEIPT_CASH && receipt_state.bank_transaction_id) ||
              receipt_state.receipt_type === INCOME_TYPE.MR_LONG_RECEIPT ||
              receipt_state.receipt_type === INCOME_TYPE.RECEIPT_UNDISTRIBUTED_EARNING
          "
          v-model="receipt_state.building"
          :items="list_building"
          prepend-icon="domain"
          :rules="
            [
              INCOME_TYPE.RECEIPT_ROOM,
              INCOME_TYPE.RECEIPT_DEPOSIT,
              INCOME_TYPE.RECEIPT_CASH,
              INCOME_TYPE.ADDITIONAL_DEPOSIT,
            ].includes(receipt_state.receipt_type)
              ? [rules.required]
              : []
          "
          :required="
            [INCOME_TYPE.RECEIPT_ROOM, INCOME_TYPE.RECEIPT_DEPOSIT, INCOME_TYPE.ADDITIONAL_DEPOSIT].includes(
              receipt_state.receipt_type
            )
          "
          @change="
            receipt_state.receipt_type === INCOME_TYPE.RECEIPT_CASH &&
              findReceiptCash()
          "
        ></v-select>
      </v-flex>
      <v-flex xs12 md3>
        <v-autocomplete
          label="Số phòng"
          :disabled="
            loading.submit ||
              loading.form ||
              [INCOME_TYPE.RECEIPT_CASH, INCOME_TYPE.RECEIPT_OTHER, INCOME_TYPE.RECEIPT_LOAN, INCOME_TYPE.RECEIPT_GAM, INCOME_TYPE.MR_LONG_RECEIPT, INCOME_TYPE.RECEIPT_UNDISTRIBUTED_EARNING].includes(
                receipt_state.receipt_type
              )
          "
          v-model="receipt_state.room_id"
          :items="room_ids"
          item-text="room_id"
          item-value="rooms_id"
          prepend-icon="meeting_room"
          :rules="
            [INCOME_TYPE.RECEIPT_ROOM, INCOME_TYPE.RECEIPT_DEPOSIT, INCOME_TYPE.ADDITIONAL_DEPOSIT].includes(
              receipt_state.receipt_type
            )
              ? [rules.required]
              : []
          "
          :required="
            [INCOME_TYPE.RECEIPT_ROOM, INCOME_TYPE.RECEIPT_DEPOSIT, INCOME_TYPE.ADDITIONAL_DEPOSIT].includes(
              receipt_state.receipt_type
            )
          "
          @change="receipt_state.receipt_type === INCOME_TYPE.ADDITIONAL_DEPOSIT ? findReceiptReturnDeposit() : findReceiptPayment()"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 md3>
        <v-text-field
          label="Mã chứng từ"
          disabled
          v-model="receipt_state.receipt_id"
          prepend-icon="label"
          required
          :rules="[rules.required]"
        ></v-text-field>
      </v-flex>
      <template
        v-if="
          [
            INCOME_TYPE.RECEIPT_ROOM,
            INCOME_TYPE.RECEIPT_OTHER,
            INCOME_TYPE.RECEIPT_CASH,
            INCOME_TYPE.RECEIPT_LOAN,
            INCOME_TYPE.RECEIPT_GAM,
            INCOME_TYPE.ADDITIONAL_DEPOSIT,
            INCOME_TYPE.MR_LONG_RECEIPT,
            INCOME_TYPE.RECEIPT_UNDISTRIBUTED_EARNING,
          ].includes(receipt_state.receipt_type)
        "
      >
        <v-flex xs12 md3>
          <v-text-field
            :label="
              `Số tiền thu${
                bill_data
                  ? ' (Hóa đơn tiền phòng: ' +
                    formatCurrency(bill_data.total_bill) +
                    ')'
                  : ''
              }`
            "
            :disabled="
              loading.submit ||
                loading.form ||
                alert.show ||
                !receipt_state.receipt_type ||
                [INCOME_TYPE.RECEIPT_CASH, INCOME_TYPE.ADDITIONAL_DEPOSIT].includes(receipt_state.receipt_type)
            "
            v-model="receipt_state.collected_amount"
            prepend-icon="money"
            required
            :rules="[
              rules.required,
              (value) => isValidAmount(value, receipt_state.receipt_type),
            ]"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md3
          v-if="
            [
              INCOME_TYPE.RECEIPT_LOAN,
            ].includes(receipt_state.receipt_type)
          "
        >
          <v-select
          :items="LOAN_OBJECT_OPTIONS"
          :disabled="loading.submit || loading.form"
          :rules="[rules.required]"
          v-model="receipt_state.loan_object"
          prepend-icon="person"
          label="Đối tượng"
        ></v-select>
        </v-flex>
        <v-flex xs12 md3>
          <v-menu
            :close-on-content-click="false"
            v-model="menu_receipt_date_collected"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
            disabled
          >
            <v-text-field
              slot="activator"
              v-model="receipt_state.date_collected"
              label="Ngày tạo phiếu"
              disabled
              prepend-icon="event"
              readonly
              :rules="[rules.required]"
            ></v-text-field>
            <v-date-picker
              locale="vi-VI"
              v-model="receipt_state.date_collected"
              @input="menu_receipt_date_collected = false"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex
          xs12
          md3
          v-if="[INCOME_TYPE.RECEIPT_ROOM].includes(receipt_state.receipt_type)"
        >
          <v-menu
            :close-on-content-click="false"
            v-model="menu_receipt_data_month"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="receipt_state.month"
              label="Chọn tháng"
              :disabled="loading.submit"
              prepend-icon="event"
              readonly
              :rules="[rules.required]"
            ></v-text-field>
            <v-date-picker
              min="2019-10"
              locale="vi-VI"
              type="month"
              v-model="receipt_state.month"
              @change="findReceiptPayment()"
              @input="menu_receipt_data_month = false"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 md12>
          <v-text-field
            v-if="![INCOME_TYPE.RECEIPT_CASH].includes(receipt_state.receipt_type)"
            label="Ghi chú"
            :disabled="loading.submit || loading.form || alert.show"
            v-model="receipt_state.note"
            prepend-icon="event_note"
            :rules="
              receipt_state.receipt_type === INCOME_TYPE.RECEIPT_OTHER
                ? [rules.required]
                : []
            "
            :required="receipt_state.receipt_type === INCOME_TYPE.RECEIPT_OTHER"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 v-if="alert.show">
          <v-alert :value="alert.show" :type="alert.type" outline>{{
            alert.text
          }}</v-alert>
        </v-flex>
        <v-flex
          xs12
          v-if="
            receipt_state.receipt_type === INCOME_TYPE.RECEIPT_CASH &&
              list_receipt_cash.length
          "
        >
          <v-radio-group v-model="chosen_receipt_cash" row>
            <v-radio
              v-for="receipt_cash in list_receipt_cash"
              :key="receipt_cash.receipt_id"
              :label="
                `Phiếu thu tiền mặt: ${
                  receipt_cash.receipt_id
                } - Số tiền: ${formatCurrency(receipt_cash.amount)}`
              "
              :value="receipt_cash"
              color="primary"
            ></v-radio>
          </v-radio-group>
        </v-flex>
      </template>
      <template
        v-if="
          receipt_state.receipt_type === INCOME_TYPE.RECEIPT_DEPOSIT &&
            receipt_state.room_state_id
        "
      >
        <v-flex xs12 md3>
          <v-menu
            :close-on-content-click="false"
            v-model="menu_date_deposit"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="receipt_state.date_deposit"
              label="Ngày đặt cọc"
              disabled
              prepend-icon="event"
              readonly
              :rules="requireText"
            ></v-text-field>
            <v-date-picker
              locale="vi-VI"
              v-model="receipt_state.date_deposit"
              @input="menu_date_deposit = false"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex v-if="receipt_state.deposit_type === 1" xs12 md3>
          <v-menu
            :close-on-content-click="false"
            v-model="menu_date_schedule_in"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="receipt_state.date_schedule_in"
              label="Ngày hẹn vào ở"
              :disabled="loading.submit"
              prepend-icon="event"
              readonly
              :rules="requireText"
            ></v-text-field>
            <v-date-picker
              locale="vi-VI"
              v-model="receipt_state.date_schedule_in"
              @input="menu_date_schedule_in = false"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex v-if="receipt_state.deposit_type === 1" xs12 md3>
          <v-select
            label="Người dẫn phòng"
            :disabled="loading.submit"
            v-model="receipt_state.agent"
            :items="[...bvs, { name: 'Chuyển phòng' }]"
            item-text="name"
            return-object
            prepend-icon="person_pin"
            required
          ></v-select>
        </v-flex>
        <v-flex xs12 md3>
          <v-text-field
            label="Họ tên người nộp tiền"
            :disabled="loading.submit"
            v-model="receipt_state.name"
            prepend-icon="account_box"
            required
            :rules="requireText"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md3>
          <v-text-field
            label="Số điện thoại"
            :disabled="loading.submit"
            v-model="receipt_state.phone"
            prepend-icon="contact_phone"
            required
            :rules="requirePhone"
          ></v-text-field>
        </v-flex>
        <v-flex v-if="receipt_state.deposit_type === 1" xs12 md3>
          <v-text-field
            label="Giá phòng:"
            v-model="receipt_state.room_price"
            required
            prepend-icon="attach_money"
            :rules="requireNumber"
          >
            <template slot="append">
              VND
            </template>
          </v-text-field>
        </v-flex>
        <v-flex xs12 md3>
          <v-text-field
            label="Số tiền hiện cọc:"
            :disabled="loading.submit"
            v-model="receipt_state.deposit_amount"
            required
            prepend-icon="attach_money"
            :rules="[...requireNumber, isValidDeposit]"
          >
            <template slot="append">
              VND
            </template>
          </v-text-field>
        </v-flex>
        <v-flex xs12 md12>
          <v-text-field
            label="Ghi chú"
            :disabled="loading.submit"
            v-model="receipt_state.note"
            prepend-icon="event_note"
          >
          </v-text-field>
        </v-flex>
      </template>
    </v-layout>
  </div>
</template>

<script>
import api from "../../../api";
import {
  buildParamQuery,
  deepCopy,
  formatCurrency,
  parseCurrency,
  formatTimeServer,
} from "Helpers";
import { list_building, ACCOUNT_TYPES, LOAN_OBJECT_OPTIONS } from "Constants/db-config";
import moment from "moment";

const INCOME_TYPE = {
  RECEIPT_ROOM: ACCOUNT_TYPES.RECEIPT_ROOM,
  RECEIPT_OTHER: ACCOUNT_TYPES.RECEIPT_OTHER,
  RECEIPT_DEPOSIT: "receipt_deposit",
  ADDITIONAL_DEPOSIT: ACCOUNT_TYPES.ADDITIONAL_DEPOSIT,
  RECEIPT_CASH: "receipt_cash",
  RECEIPT_LOAN: "receipt_loan",
  RECEIPT_GAM: "receipt_gam",
  MR_LONG_RECEIPT: "mr_long_receipt",
  RECEIPT_UNDISTRIBUTED_EARNING: "receipt_undistributed_earning",
};

const RECEIPT_INCOME_TYPE = [
  { text: "Thu tiền phòng", value: INCOME_TYPE.RECEIPT_ROOM },
  { text: "Thu tiền cọc", value: INCOME_TYPE.RECEIPT_DEPOSIT },
  { text: "Thu thêm tiền cọc", value: INCOME_TYPE.ADDITIONAL_DEPOSIT },
  { text: "Thu tiền mặt", value: INCOME_TYPE.RECEIPT_CASH },
  { text: "Thu tiền khác", value: INCOME_TYPE.RECEIPT_OTHER },
  { text: "Thu tiền đi vay", value: INCOME_TYPE.RECEIPT_LOAN },
  { text: "Thu công nợ Cô Gấm", value: INCOME_TYPE.RECEIPT_GAM },
  { text: "Thu tiền anh Long", value: INCOME_TYPE.MR_LONG_RECEIPT },
  { text: "Thu lợi nhuận chưa phân phối", value: INCOME_TYPE.RECEIPT_UNDISTRIBUTED_EARNING },
];

// Hậu tố mã phiếu theo loại thu.
// Trước đây bảng ánh xạ này chỉ nằm trong watcher `receipt_state.receipt_type`,
// còn watcher `totalReceiptCount` lại dựng mã KHÔNG có hậu tố. Hệ quả: khi số phiếu
// trong dialog thay đổi, mã phiếu bị đổi từ `VCB.U1.4.26.49.5.TTP` thành
// `VCB.U1.4.26.49.5` -> cùng một phiếu mang 2 mã khác nhau (NT-250).
const RECEIPT_ID_POSTFIX = {
  [INCOME_TYPE.RECEIPT_ROOM]: "TTP",
  [INCOME_TYPE.RECEIPT_OTHER]: "KHAC",
  [INCOME_TYPE.RECEIPT_GAM]: "KHAC",
  [INCOME_TYPE.RECEIPT_LOAN]: "VAY",
  [INCOME_TYPE.ADDITIONAL_DEPOSIT]: "TC",
  [INCOME_TYPE.MR_LONG_RECEIPT]: "AL",
  [INCOME_TYPE.RECEIPT_UNDISTRIBUTED_EARNING]: "LN",
};

export default {
  name: "card-tao-phieu-thu-tu-giao-dich",
  props: {
    index: Number,
    receipt: Object,
    transaction: Object,
    totalReceiptIndex: Number,
    totalReceiptCount: Number,
  },
  data() {
    const receipt_state = deepCopy(this.receipt);

    return {
      RECEIPT_INCOME_TYPE,
      LOAN_OBJECT_OPTIONS,
      INCOME_TYPE,
      menu_receipt_date_collected: false,
      menu_date_deposit: false,
      menu_date_schedule_in: false,
      menu_receipt_data_month: false,
      over_collected_amount_allowed: 200000,
      formatCurrency,
      parseCurrency,
      requireNumber: [
        (v) => !!v || "Vui lòng nhập thông tin này",
        (v) => (v && /^[0-9]*$/.test(parseCurrency(v))) || "Vui lòng nhập số",
      ],
      requireText: [(v) => !!v || "Vui lòng nhập thông tin này"],
      requirePhone: [
        (v) => !!v || "Vui lòng nhập thông tin này",
        (v) => (v && v.length <= 10) || "SDT phải ngắn hơn 10 ký tự",
      ],
      rules: {
        required: (value) => !!value || "Vui lòng điền thông tin này.",
      },
      receipt_state: receipt_state,
      list_building,
      loading: {
        submit: false,
        form: false,
      },
      alert: {
        show: false,
        text: "",
        type: "error",
      },
      chosen_building: "BN",
      bill_data: null,
      list_receipt_cash: [],
      chosen_receipt_cash: undefined,
      chosen_return_deposit: undefined,
    };
  },
  computed: {
    rooms() {
      return this.$store.state.app.rooms;
    },
    room_ids() {
      return this.rooms.filter(
        (room) => room.building === this.receipt_state.building
      );
    },
    bvs() {
      return this.$store.state.app.bvs;
    },
  },
  watch: {
    totalReceiptCount: function(nv) {
      // Phiếu đã lưu thì mã phiếu đã nằm trong DB (và journal tham chiếu theo mã đó),
      // đánh số lại sẽ tạo ra một mã thứ hai cho cùng một phiếu.
      if (this.receipt_state.isEdit) {
        return;
      }

      if (
        !this.receipt_state.receipt_id.startsWith(
          this.transaction.bank_receipt_id
        )
      ) {
        return;
      }

      this.receipt_state.receipt_id = this.buildReceiptId(
        this.receipt_state.receipt_type
      );
    },
    "receipt_state.building": function(nv, ov) {
      if (this.receipt_state.receipt_type === INCOME_TYPE.RECEIPT_CASH && nv !== ov) {
        this.chosen_receipt_cash = undefined;
        this.chosen_return_deposit = undefined;
      }
    },
    "receipt_state.collected_amount": function(nv) {
      const parsedValue = parseCurrency(nv) || 0;

      this.receipt_state.collected_amount = formatCurrency(parsedValue);
      // Sync primary_amount with collected_amount for receipt_room
      if (this.receipt_state.receipt_type === INCOME_TYPE.RECEIPT_ROOM) {
        this.receipt_state.primary_amount = formatCurrency(parsedValue);
      }
    },
    "receipt_state.receipt_type": function(nv) {
      this.receipt_state.room_id = "";
      this.receipt_state.building = "";
      this.receipt_state.collected_amount = "";

      if ([this.INCOME_TYPE.RECEIPT_ROOM, this.INCOME_TYPE.RECEIPT_OTHER, this.INCOME_TYPE.RECEIPT_LOAN, this.INCOME_TYPE.RECEIPT_GAM, this.INCOME_TYPE.ADDITIONAL_DEPOSIT, this.INCOME_TYPE.MR_LONG_RECEIPT, this.INCOME_TYPE.RECEIPT_UNDISTRIBUTED_EARNING].includes(nv)) {
        if (nv === this.INCOME_TYPE.MR_LONG_RECEIPT) {
          this.receipt_state.collected_amount = formatCurrency(
            this.transaction.amount
          );
        }

        this.receipt_state.receipt_id = this.buildReceiptId(nv);
      } else {
        this.receipt_state.receipt_id = "";
      }
     
      this.bill_data = null;
      this.chosen_receipt_cash = undefined;
      this.chosen_return_deposit = undefined;

      this.receipt_state.wallet_account_id = nv === INCOME_TYPE.RECEIPT_CASH ? undefined : this.transaction.wallet_account_id;

      if (nv === INCOME_TYPE.RECEIPT_ROOM) {
        this.receipt_state.month = moment(this.receipt_state.month, "YYYY-MM")
          .subtract(1, "months")
          .format("YYYY-MM");
      } else {
        this.receipt_state.month = this.receipt.month;
      }

      if (nv === INCOME_TYPE.RECEIPT_DEPOSIT) {
        const EMPTY_RECEIPT_DEPOSIT = {
          date_deposit: formatTimeServer(
            this.transaction.date_action,
            "YYYY-MM-DD"
          ),
          name: "",
          phone: "",
          building: "",
          room_id: "",
          room_price_old: "2.700.000",
          room_price: "2.700.000",
          deposit_amount: "1.000.000",
          deposit_price: "1.000.000",
          deposit_price_old: "1.000.000",
          date_schedule_in: formatTimeServer(
            this.transaction.date_action,
            "YYYY-MM-DD"
          ),
          note: "",
          agent: "",
          room_state_id: "",
          deposit_type: 1,
          loan_object: "",
        };

        this.receipt_state = deepCopy({
          ...this.receipt_state,
          ...EMPTY_RECEIPT_DEPOSIT,
        });
      }
    },
    receipt_state: {
      handler: function(nv) {
        this.$emit("setReceiptListState", nv, this.index);
      },
      deep: true,
    },
    receipt: {
      handler: function(nv) {
        console.log("🚀 ~ nv:", nv)
        this.receipt_state = deepCopy(nv);
      },
      deep: true,
    },
    "receipt_state.room_id"(nv) {
      this.chosen_return_deposit = undefined;
      if (
        nv &&
        this.receipt_state.receipt_type === INCOME_TYPE.RECEIPT_DEPOSIT
      ) {
        this.getRoomState(nv);
        const chosen_room = this.rooms.find((room) => room.room_id == nv);
        this.receipt_state.room_price =
          chosen_room && chosen_room.room_price
            ? chosen_room.room_price
            : 2700000;
        this.receipt_state.room_price_old =
          chosen_room && chosen_room.room_price
            ? chosen_room.room_price
            : 2700000;
        this.receipt_state.deposit_price =
          chosen_room && chosen_room.deposit_price
            ? chosen_room.room_price
            : 2700000;
        this.receipt_state.deposit_price_old =
          chosen_room && chosen_room.deposit_price
            ? chosen_room.room_price
            : 2700000;
        this.receipt_state.deposit_amount =
          chosen_room && chosen_room.deposit_price
            ? chosen_room.room_price
            : 2700000;
      }
    },
    "receipt_state.room_price": function(nv) {
      this.receipt_state.room_price =
        nv && this.receipt_state.receipt_type === INCOME_TYPE.RECEIPT_DEPOSIT
          ? nv
              .toString()
              .replace(/\./g, "")
              .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          : "";
    },
    "receipt_state.deposit_amount": function(nv, ov) {
      this.receipt_state.deposit_amount =
        nv && this.receipt_state.receipt_type === INCOME_TYPE.RECEIPT_DEPOSIT
          ? nv
              .toString()
              .replace(/\./g, "")
              .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          : "0";
    },
    "receipt_state.room_price_old": function(nv, ov) {
      this.receipt_state.room_price_old =
        nv && this.receipt_state.receipt_type === INCOME_TYPE.RECEIPT_DEPOSIT
          ? nv
              .toString()
              .replace(/\./g, "")
              .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          : "";
    },
    "receipt_state.deposit_price": function(nv, ov) {
      this.receipt_state.deposit_price =
        nv && this.receipt_state.receipt_type === INCOME_TYPE.RECEIPT_DEPOSIT
          ? nv
              .toString()
              .replace(/\./g, "")
              .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
          : "";
    },
    chosen_receipt_cash: function(nv) {
      if (nv) {
        this.receipt_state.collected_amount = formatCurrency(nv.amount);
        this.receipt_state._id = nv._id;
        this.receipt_state.receipt_id = nv.receipt_id;
        this.receipt_state.wallet_account_id = nv.wallet_account_id;
      } else {
        this.receipt_state.collected_amount = "";
      }
    },
    chosen_return_deposit(nv) {
      if (nv) {
        this.receipt_state.collected_amount = formatCurrency(-nv.amount);
        this.receipt_state.check_out_id = nv.check_out_id;
      } else {
        this.receipt_state.check_out_id = "";
        this.receipt_state.collected_amount = "";
      }
    },
  },
  methods: {
    // Dựng mã phiếu từ mã giao dịch ngân hàng + số thứ tự + hậu tố theo loại thu.
    // Dùng chung cho mọi nơi cần sinh mã để hậu tố không bị rơi mất.
    buildReceiptId(receipt_type) {
      const base = `${this.transaction.bank_receipt_id}.${this.totalReceiptIndex}`;
      const postfix = RECEIPT_ID_POSTFIX[receipt_type];

      return postfix ? `${base}.${postfix}` : base;
    },
    handleRoomState: function(room_state) {
      let arr = room_state.split("-");
      arr[1] = Number(arr[1]) + 1;
      return arr.join("-");
    },
    getRoomState: async function(roomId) {
      this.form_loader = true;
      this.alert.show = false;
      this.total_amount_must_deposit = 0;
      this.total_amount_deposited = 0;
      const data = await api.getRoomState("roomId=" + roomId);
      if (data.status == 200) {
        const roomState = data.data ? data.data.roomState : null;
        const old_room_state_id = roomState
          ? data.data.roomState.room_state_id
          : null;
        const date_schedule_out = roomState
          ? data.data.roomState.date_schedule_out
          : null;
        const is_valid_room_state = roomState
          ? data.data.roomState.is_valid
          : null;

        if (
          is_valid_room_state &&
          old_room_state_id &&
          !roomState.date_schedule_out
        ) {
          this.receipt_state.deposit_type = roomState.deposits.length + 1;
          this.receipt_state.room_state_id = old_room_state_id;
          const total_amount_deposited = roomState.deposits.reduce(
            (acc, cur) => acc + cur.deposit_amount,
            0
          );
          const data_old_deposit = await api.getDepositReceipts(
            "receiptId=" +
              roomState.deposits[roomState.deposits.length - 1].receipt_id
          );
          const old_deposit = data_old_deposit.data[0];
          this.receipt_state.name = roomState.name;
          this.receipt_state.phone = roomState.phone;
          if (old_deposit) {
            this.receipt_state.room_price = old_deposit.room_price;
            this.receipt_state.room_price_old = old_deposit.room_price;
            this.receipt_state.deposit_price = old_deposit.deposit_price;
            this.receipt_state.deposit_price_old = old_deposit.deposit_price;
            this.receipt_state.deposit_amount =
              old_deposit.deposit_price +
              old_deposit.room_price -
              total_amount_deposited;
            this.total_amount_must_deposit =
              old_deposit.deposit_price + old_deposit.room_price;
          } else {
            const params = {
              roomId: this.receipt_state.room_id,
              building: this.receipt_state.building,
              contractValid: true,
            };
            const query = buildParamQuery(params);
            const constract_data = await api.getListContracts(query);
            if (
              constract_data.status !== 200 ||
              !constract_data.data.contracts[0]
            ) {
              this.alert.show = true;
              this.alert.text = data.message
                ? data.message
                : "Lỗi khi tải thông tin trạng thái phòng";
              return;
            }
            const room_contract = constract_data.data.contracts[0];
            this.receipt_state.room_price = room_contract.room_price;
            this.receipt_state.room_price_old = room_contract.room_price;
            this.receipt_state.deposit_price = room_contract.deposit_price;
            this.receipt_state.deposit_price_old = room_contract.deposit_price;
            this.receipt_state.deposit_amount =
              room_contract.deposit_price +
              room_contract.room_price -
              total_amount_deposited;
            this.total_amount_must_deposit =
              room_contract.deposit_price + room_contract.room_price;
          }
          this.total_amount_deposited = total_amount_deposited;
        } else {
          const new_room_state_id = old_room_state_id
            ? this.handleRoomState(old_room_state_id)
            : `${this.receipt_state.room_id}-1`;
          this.receipt_state.deposit_type = 1;
          this.receipt_state.name = "";
          this.receipt_state.phone = "";
          this.receipt_state.room_state_id = new_room_state_id;
        }
        this.receipt_state.receipt_id = `${this.transaction.bank_receipt_id}.${
          this.totalReceiptIndex
        }.CL${this.receipt_state.deposit_type}`;
      } else {
        this.alert.show = true;
        this.alert.text = data.message
          ? data.message
          : "Lỗi khi tải thông tin trạng thái phòng";
      }
      this.form_loader = false;
    },
    findReceiptPayment: async function() {
      if (
        !this.receipt_state.room_id ||
        !this.receipt_state.month ||
        this.receipt_state.receipt_type !== INCOME_TYPE.RECEIPT_ROOM
      ) {
        return;
      }

      this.alert.show = false;
      this.loading.form = true;
      this.receipt_state.note = "";
      this.receipt_state.room_state_id = "";
      this.receipt_state.collected_amount = "";
      this.bill_data = null;

      const params = {
        roomId: this.receipt_state.room_id,
        month: this.receipt_state.month,
      };
      const query = buildParamQuery(params);
      const data = await api.findPayment(query);

      this.loading.form = false;
      if (data.status === 200 && data.data) {
        this.bill_data = data.data;

        const amount = data.data.total_bill - data.data.collected_amount;
        this.receipt_state.collected_amount = amount;
        this.receipt_state.primary_amount = amount;
        this.receipt_state.original_debt = amount;
        this.receipt_state.room_state_id = data.data.room_state_id;
        this.receipt_state.list_receipt_room_id = data.data.receipt_room_id;
      } else {
        this.alert.show = true;
        this.alert.text = `Phòng hiện không có thông tin thu tiền cho phòng ${
          this.receipt_state.room_id
        } vào tháng ${this.receipt_state.month}`;
      }
    },
    findReceiptCash: async function() {
      const params = {
        building: this.receipt_state.building,
        isLinkedBankTransaction: false,
      };
      const query = buildParamQuery(params);
      const result = await api.findReceiptCash(query);

      this.list_receipt_cash = result.data;
    },
    findReceiptReturnDeposit: async function() {
      this.alert.show = false;
      this.loading.submit = true;
      const params = {
        roomId: this.receipt_state.room_id,
        additionalDepositReceiptId: false,
      };
      const query = buildParamQuery(params);
      const data = await api.getListReturnDeposit(query);

      if (data.status == 200) {
        this.list_return_deposits = data.data.slice(0, 1);
        const foundDeposit = this.list_return_deposits.length ? this.list_return_deposits.find((e) => e.amount < 0) : undefined;
        if (!foundDeposit) {
          this.alert.show = true;
          this.alert.text = `Không tìm thấy phiếu trả phòng cần thu thêm của phòng ${
            this.receipt_state.room_id
          }`;
        } else {
          this.chosen_return_deposit = foundDeposit;
        }
      } else {
        this.alert.show = true;
        this.alert.text = "Lỗi không tìm thấy dữ liệu";
      }

      this.loading.submit = false;
    },
    updateCurrentReceipt(_id, updated_field) {
      const selected_receipt = this.items.find(
        (receipt) => receipt._id === _id
      );
      for (const key in updated_field) {
        if (updated_field.hasOwnProperty(key)) {
          const element = updated_field[key];
          selected_receipt[key] = element;
        }
      }
    },
    removeReceipt: function(index) {
      this.$emit("removeReceipt", index);
    },
    isValidAmount: function(value, type) {
      if (type !== INCOME_TYPE.RECEIPT_ROOM) return true;
      if (this.receipt_state.original_debt === undefined || this.receipt_state.original_debt === null) return true;

      const amount = +(value || "").toString().replace(/\./g, "");
      const remaining_amount = this.receipt_state.original_debt;
      return (
        amount <= remaining_amount + this.over_collected_amount_allowed ||
        `Số tiền thu không được vượt quá 200,000đ so với số tiền còn nợ ${formatCurrency(
          remaining_amount
        )}đ`
      );
    },
    isValidDeposit: function(value) {
      if (!this.total_amount_must_deposit || !this.total_amount_deposited)
        return true;

      const amount = +value.replace(/\./g, "");
      return (
        amount <=
          this.total_amount_must_deposit - this.total_amount_deposited ||
        `Số tiền đặt cọc không được quá số tiền cọc quy định của phòng`
      );
    },
  },
};
</script>

<style scoped>
.border-top {
  padding-top: 9px;
  border-top: 1px solid #ddd;
}
</style>
